import { Link } from "gatsby"
import React, { useState, Fragment } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Menu, Transition, Dialog } from "@headlessui/react"
import { ChevronDownIcon, MenuIcon } from "@heroicons/react/solid"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

function Header() {
  const [isExpanded, toggleExpansion] = useState(false)
  let [isOpen, setIsOpen] = useState(false)

  return (
    <nav className="flex h-32 w-full flex-row justify-between  bg-bump-gray px-8  lowercase xl:px-32">
      <Link to="/" className="h-full w-32 pt-8">
        <StaticImage
          src="../images/logo_BUMP-white.png"
          placeholder="blurred"
          layout="fullWidth"
          alt="BUMP Logo"
          quality="100"
          width={200}
        />
      </Link>
      <div className="flex justify-center align-middle xl:hidden">
        <button
          onClick={() => setIsOpen(true)}
          className="  rounded-sm px-3 py-2 text-stone-100"
        >
          <MenuIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>

      <Transition
        show={isOpen}
        enter="transition duration-200 ease-out"
        enterFrom=" opacity-0"
        enterTo=" opacity-100"
        leave="transition duration-100 ease-out"
        leaveFrom=" opacity-100"
        leaveTo="  opacity-0"
        as={Fragment}
      >
        <Dialog onClose={() => setIsOpen(false)} className="relative z-50">
          <div className="fixed inset-0  bg-black/50" aria-hidden="true" />
          <div className="fixed top-0 right-0 flex  items-center justify-center">
            <Dialog.Panel className="h-screen w-full max-w-sm bg-bump-gray text-white">
              <div className="flex flex-col justify-start space-y-16 px-12 py-12 font-Roboto text-2xl font-bold lowercase md:px-28 md:text-3xl">
                <Link
                  to={`/pricing`}
                  className="mt-4 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
                >
                  Pricing
                </Link>

                <Link
                  to={`/first-time`}
                  className="mt-4  block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
                >
                  First Time
                </Link>

                <Menu
                  as="div"
                  className=" relative z-50 block text-left lg:inline-block"
                >
                  <div>
                    <Menu.Button className="mt-4 inline-flex  items-center font-Roboto font-bold text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:ml-0 lg:mt-0 lg:inline-flex">
                      courses
                      <ChevronDownIcon
                        className="-mr-1 ml-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                    as={Fragment}
                  >
                    <Menu.Items className="absolute right-0 z-50 mt-2 w-56 origin-top-left divide-y divide-stone-100 divide-opacity-5 rounded-sm bg-zinc-800 shadow-lg ring-1 ring-bump-yellow ring-opacity-5 focus:outline-none">
                      <div>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/classes"
                              className={classNames(
                                active
                                  ? "bg-slate-700 text-stone-100"
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base "
                              )}
                            >
                              All Courses
                            </Link>
                          )}
                        </Menu.Item>
                      </div>
                      <div>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/intro-to-bouldering"
                              className={classNames(
                                active
                                  ? "z-50 bg-slate-700 text-stone-100"
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base font-normal"
                              )}
                            >
                              ▸ Introduction to Bouldering
                            </Link>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/discover-movement"
                              className={classNames(
                                active
                                  ? "bg-slate-700 text-stone-100 "
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base font-normal"
                              )}
                            >
                              ▸ Discover Movement
                            </Link>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>

                <Menu
                  as="div"
                  className=" relative  block text-left lg:inline-block"
                >
                  <div>
                    <Menu.Button className="font-roboto z-0  mt-4 inline-flex items-center font-bold text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:ml-0 lg:mt-0 lg:inline-flex">
                      resources
                      <ChevronDownIcon
                        className="-mr-1 ml-2 h-5 w-5"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className=" absolute right-0 z-50 mt-2 w-56 origin-top-left divide-y divide-stone-100 divide-opacity-5 rounded-sm bg-zinc-800 shadow-lg ring-1 ring-bump-yellow ring-opacity-5 focus:outline-none">
                      <div>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/FAQ"
                              className={classNames(
                                active
                                  ? "bg-slate-700 text-stone-100"
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base uppercase"
                              )}
                            >
                              FAQ
                            </Link>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/bouldering-at-bump"
                              className={classNames(
                                active
                                  ? "bg-slate-700 text-stone-100"
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base"
                              )}
                            >
                              bouldering at bump
                            </Link>
                          )}
                        </Menu.Item>
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              to="/facilities"
                              className={classNames(
                                active
                                  ? "bg-slate-700 text-stone-100"
                                  : "text-stone-100",
                                "block px-4 py-2 font-Roboto text-base "
                              )}
                            >
                              facilities
                            </Link>
                          )}
                        </Menu.Item>
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>

                <Link
                  to={`/contact`}
                  className="z-10 mt-4 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
                >
                  Contact
                </Link>
                <a
                  href="https://bumpbouldering.storehub.me/"
                  color="#292524"
                  className="mt-4 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shop
                </a>
              </div>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Transition>

      <div
        className={`hidden w-full flex-grow items-center  xl:flex xl:w-auto`}
      >
        <div className=" flex w-full flex-row justify-end font-Roboto text-2xl font-bold  lg:space-x-6 xl:space-x-7">
          <Link
            to={`/pricing`}
            className="z-10 mt-4 ml-6 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
          >
            Pricing
          </Link>

          <Link
            to={`/first-time`}
            className="z-10 mt-4 ml-6 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
          >
            First Time
          </Link>

          <Menu
            as="div"
            className=" relative z-50 block text-left lg:inline-block"
          >
            <div>
              <Menu.Button className="z-10 mt-4 ml-6 inline-flex  items-center font-Roboto font-bold text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:ml-0 lg:mt-0 lg:inline-flex">
                courses
                <ChevronDownIcon
                  className="-mr-1 ml-2 h-5 w-5"
                  aria-hidden="true"
                />
              </Menu.Button>
            </div>

            <Transition
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
              as={Fragment}
            >
              <Menu.Items className="absolute right-0 z-50 mt-2 w-56 origin-top-left divide-y divide-stone-100 divide-opacity-5 rounded-sm bg-zinc-800 shadow-lg ring-1 ring-bump-yellow ring-opacity-5 focus:outline-none">
                <div>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/classes"
                        className={classNames(
                          active
                            ? "bg-slate-700 text-stone-100"
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm "
                        )}
                      >
                        All Courses
                      </Link>
                    )}
                  </Menu.Item>
                </div>
                <div>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/intro-to-bouldering"
                        className={classNames(
                          active
                            ? "z-50 bg-slate-700 text-stone-100"
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm font-normal"
                        )}
                      >
                        ▸ Introduction to Bouldering
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/discover-movement"
                        className={classNames(
                          active
                            ? "bg-slate-700 text-stone-100 "
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm font-normal"
                        )}
                      >
                        ▸ Discover Movement
                      </Link>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Menu as="div" className=" relative  block text-left lg:inline-block">
            <div>
              <Menu.Button className="font-roboto z-0  ml-6 mt-4 inline-flex items-center font-bold text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:ml-0 lg:mt-0 lg:inline-flex">
                resources
                <ChevronDownIcon
                  className="-mr-1 ml-2 h-5 w-5"
                  aria-hidden="true"
                />
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className=" absolute right-0 z-50 mt-2 w-56 origin-top-left divide-y divide-stone-100 divide-opacity-5 rounded-sm bg-zinc-800 shadow-lg ring-1 ring-bump-yellow ring-opacity-5 focus:outline-none">
                <div>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/FAQ"
                        className={classNames(
                          active
                            ? "bg-slate-700 text-stone-100"
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm uppercase"
                        )}
                      >
                        FAQ
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/bouldering-at-bump"
                        className={classNames(
                          active
                            ? "bg-slate-700 text-stone-100"
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm"
                        )}
                      >
                        bouldering at bump
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <Link
                        to="/facilities"
                        className={classNames(
                          active
                            ? "bg-slate-700 text-stone-100"
                            : "text-stone-100",
                          "block px-4 py-2 font-Roboto text-sm "
                        )}
                      >
                        facilities
                      </Link>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>

          <Link
            to={`/contact`}
            className="z-10 mt-4 ml-6 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
          >
            Contact
          </Link>
          <a
            href="https://bumpbouldering.storehub.me/"
            color="#292524"
            className="mt-4 ml-6 block text-stone-100 duration-100 ease-in-out hover:text-bump-yellow lg:mt-0 lg:inline-block"
            target="_blank"
            rel="noopener noreferrer"
          >
            Shop
          </a>
        </div>
      </div>
    </nav>
  )
}

export default Header
